export const NOTIFICATIONS_TYPES = {
  DEFAULT: 0,
  CUSTOM_MAIL: 1,
  SESSION: 2,
  COMMUNITY_POST: 3,
  COMMUNITY_BONUS_OFFERING: 4,
  NEW_POST_BY_CUSTOMER: 5,
  RECORDED_CONTENT: 6,
  PAYMENT: 7,
};

export const NOTIFICATIONS_TYPES_BASED_CTA_TEXT = {
  [NOTIFICATIONS_TYPES.RECORDED_CONTENT]: `Go to Course`,
  [NOTIFICATIONS_TYPES.PAYMENT]: `Pay Now`,
  [NOTIFICATIONS_TYPES.COMMUNITY_BONUS_OFFERING]: `Go to Community`,
  [NOTIFICATIONS_TYPES.COMMUNITY_POST]: `Go to Community`,
  [NOTIFICATIONS_TYPES.SESSION]: `Join Session`,
};
